<ph-dialog [open]="open"
           brand
           size="lg"
           icon="shield-check"
           [heading]="copy.title"
           [description]="copy.message"
           [dismissible]="dismissible && !locked"
           [noClose]="!dismissible || locked"
           (ph-close)="onPhClose()">

    <ng-container *ngIf="!activeSetup">
        <ph-stack>
            <ph-alert status="information">For reliable access, set up both an authenticator app and SMS — that way a second method is available if you ever lose the first.</ph-alert>

            <app-two-factor-auth [compact]="true"
                                 [highlight2fa]="true"
                                 (setupRequested)="onSetupRequested($event)"
                                 (enrollmentChecked)="onEnrollmentChecked($event)"></app-two-factor-auth>
        </ph-stack>

        <ph-actions slot="footer" align="start">
            <ph-button variant="secondary" mode="filled" (click)="onDismiss()">{{ dismissible ? 'Maybe later' : 'Cancel' }}</ph-button>
        </ph-actions>
    </ng-container>

    <ng-container *ngIf="activeSetup === 'google'">
        <app-google-auth-setup-step #googleStep
                                    dismissLabel="Back"
                                    (completed)="onStepCompleted()"
                                    (showingRecoveryCodes)="onShowingRecoveryCodes()"
                                    (cancelled)="onStepCancelled()"></app-google-auth-setup-step>
        <ng-container *ngTemplateOutlet="googleStep.footer"></ng-container>
    </ng-container>

    <ng-container *ngIf="activeSetup === 'sms'">
        <app-sms-auth-setup-step #smsStep
                                 dismissLabel="Back"
                                 (completed)="onStepCompleted()"
                                 (showingRecoveryCodes)="onShowingRecoveryCodes()"
                                 (cancelled)="onStepCancelled()"></app-sms-auth-setup-step>
        <ng-container *ngTemplateOutlet="smsStep.footer"></ng-container>
    </ng-container>
</ph-dialog>
